import { DialogLC } from "../../../../components/ModalContainer";
import { useTranslation } from "../../../../utils/hooks/useTranslation";
import { RefObject } from "react";
import { LoginForm } from "../../../../rediaPlatform/LoginForm";

type Props = { isOpen: boolean; handleClose: () => void; onCloseFocusRef: RefObject<HTMLButtonElement | null> };

export const LoginModal = (props: Props) => {
  const { t } = useTranslation();
  return (
    <DialogLC
      heading={t("Reserver")}
      open={props.isOpen}
      onOpenChange={props.handleClose}
      finalFocusEl={() => props.onCloseFocusRef.current}
      hideCloseButton
    >
      <LoginForm />
    </DialogLC>
  );
};
